import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    // wait until DOM is ready before scrolling
    requestAnimationFrame(() => {
      const container = document.querySelector('#main-content');
      if (container) {
        container.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    });
  }, [location.pathname]); // fires on forward/back navigation

  return null;
}

// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// export default function ScrollToTop() {
//   const location = useLocation();

//   useEffect(() => {
//     const container = document.querySelector('#main-content');
//     if (container) {
//       container.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
//     } else {
//       window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
//     }
//   }, [location.pathname]); // 👈 pathname makes it work for back/forward navigation

//   return null;
// }
